import styled from 'styled-components'

import Heading from 'components/v2/Heading'
import { ReactElement, ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'

const LabelV2Wrapper = styled.div`
  margin-bottom: 5px;

  small {
    font-size: 14px;
    font-style: italic;
    font-weight: 400;
    text-transform: none;
  }
`

const Label = ({
  children,
  optional,
  className = ''
}: {
  children: ReactNode
  optional?: boolean
  className?: string
}): ReactElement => {
  return (
    <LabelV2Wrapper className={className}>
      <Heading.Label>
        {children}
        {optional && (
          <>
            &nbsp;
            <OptionalLabel>
              <FormattedMessage id="dictionary.optional" defaultMessage="Optional" />
            </OptionalLabel>
          </>
        )}
      </Heading.Label>
    </LabelV2Wrapper>
  )
}

export { Label }

export const OptionalLabel = styled.span`
  font-style: italic;
  font-weight: 400;
  text-transform: none;
`
